import { Theme } from '@mui/material/styles'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    width: '100%',
    height: '100%',
  },
  verticalGradientBar: {
    marginTop: 20,
    width: 25,
    background: 'linear-gradient(to top, #e3e3e3, #007d38)',
    borderRadius: 5,
    height: '100%',
    position: 'relative',
  },
  gradient: {
    width: '100%',
    height: '100%',
  },
  labelBottom: {
    position: 'absolute',
    bottom: -20,
    left: '50%',
    transform: 'translateX(-50%)',
    fontSize: '11px',
    color: theme.palette.textField.main,
    fontFamily: theme.typography.fontFamily,
    lineHeight: '15.55px',
  },
  labelTop: {
    position: 'absolute',
    top: -20,
    left: '50%',
    transform: 'translateX(-50%)',
    fontSize: '11px',
    color: theme.palette.textField.main,
    fontFamily: theme.typography.fontFamily,
    lineHeight: '15.55px',
  },
  mapWrapper: { display: 'flex' },
  map: { width: '100%', height: '100%' },
  wrapperGradient: {
    display: 'flex',
    height: 'auto',
    justifyContent: 'center',
    alignItems: 'center',
  },
}))
